import gql from 'graphql-tag';

export default gql`
query listFA_CustomerPayment($languageId: Int){
    fakturaAssist{
    listFA_CustomerPayment(languageId: $languageId){
		id
		name
    }
    
  }
}`;
